import request from '@/api/request'
import qs from 'qs'

export default {
  referenceNumber (payload) {
    const url = '/validate/reference-number'
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    const data = qs.stringify({ data: payload })
    return request({ method: 'POST', headers, url, data })
  }
}
